import { Row as AntdRow, type RowProps as AntdRowProps } from 'antd'
import styles from './styles.module.scss'

export interface RowProps extends AntdRowProps {
  avoidGutterHorizontalScroll?: boolean
}

export const ROW_TEST_ID = 'row-test-id'

export function Row({ avoidGutterHorizontalScroll = true, className, ...props }: RowProps) {
  const defaultClassName = className ? [className] : []
  const gutterClassname = avoidGutterHorizontalScroll ? [styles.avoidGutterHorizontalScroll] : []

  const classNames = [...defaultClassName, ...gutterClassname].join(' ')

  return <AntdRow className={classNames} data-testid={ROW_TEST_ID} {...props} />
}
